// Delegated handlers are bound immediately rather than inside $(document).ready().
// A third-party app calls jQuery.holdReady(true) and never releases it, so the
// jQuery ready queue never fires on the cart page and any callback wrapped in
// $(document).ready() would never run. Delegation off `document` works regardless
// of when the markup is parsed, so no ready gate is needed here.
(function ($) {
  $(document).on('change', '#select-sample', function () {
    var variantID = $(this).val();
    $('.quick-add-samples').attr('data-variant-id', variantID);
  });

  $(document).on('click', '.quick-add-samples', function () {
    var button = $(this);
    var ID = button.attr('data-variant-id');

    if (!ID) {
      return;
    }

    if (button.prop('disabled')) {
      return;
    }

    button.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID
      },
      dataType: 'json',
      success: function () {
        location.reload();
      },
      error: function () {
        button.prop('disabled', false);
      }
    });
  });
})(jQuery);
